import React, { Suspense } from "react";
import HomeComponent from "@/modules/customer/components/HomeComponent/Home";
import SearchVendor from "@/modules/customer/pages/SearchBroker/SearchVender";
import SettingSection from "@/modules/customer/components/SettingComponent/Setting";
import ProfileSection from "@/modules/customer/pages/ProfileSection/ProfileSection";
import VendorDetail from "@/modules/customer/pages/Broker-details/Venderdetail";
const CustomerChatInbox = React.lazy(() => import("@/modules/customer/pages/ChatInbox"));
import ProtectedRoute from "./ProtectedRoute";
import MainLayout from "@/layouts/MainLayout";
import OnboardingLayout from "@/layouts/OnBoardingLayout";
import UploadProfilePicture from "@/modules/customer/pages/UploadProfilePicture";
import Loader from "@/components/Loader";

const customerRoutes = [
  {
    path: "/customer",
    element: <ProtectedRoute><MainLayout/></ProtectedRoute>,
    children: [
      { path: "dashboard", element: <HomeComponent /> },
      { path: "search-brokers", element: <SearchVendor /> },
      {
        path: "inbox",
        element: (
          <Suspense fallback={<Loader />}>
            <CustomerChatInbox />
          </Suspense>
        ),
      },      { path: "settings", element: <SettingSection /> },
      { path: "profile", element: <ProfileSection /> },
      { path: "search-brokers/:vendorId", element: <VendorDetail /> },
      { path: "inbox/:vendorId", element: <CustomerChatInbox /> },
    ],
  },
  {
    path: "/customer/onboarding",
    element: <ProtectedRoute><OnboardingLayout/></ProtectedRoute>,
    children: [
      { path: "upload-profile-picture", element: <UploadProfilePicture /> },
    ]
  }
];

export default customerRoutes;
